const CloseModalIcon = () => (
  <svg className="close-gamification-icon" fill="none" viewBox="0 0 45 44" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.2935 34.8333L9.72681 32.2666L19.9935 22L9.72681 11.7333L12.2935 9.16663L22.5601 19.4333L32.8268 9.16663L35.3935 11.7333L25.1268 22L35.3935 32.2666L32.8268 34.8333L22.5601 24.5666L12.2935 34.8333Z"
      fill="white"
    />
  </svg>
);
export default CloseModalIcon;
